<template>
  <glowing-container
    v-if="release"
  >
    <div
      class="px-3 py-0.5 hover:opacity-50 cursor-pointer"
      @click="onPress"
    >
      <span class="text-primary text-sm">
        Voir les nouveautés 🚀 ({{ `v${version}` }})
      </span>
      <ShellUpdateLink
        v-if="shellUpdate.isVisible.value"
        :update="shellUpdate"
      />
    </div>
  </glowing-container>
  <div
    v-else
    class="flex items-center border border-gray-400 px-3 py-0.5 rounded-lg hover:opacity-50 cursor-pointer"
    @click="onPress"
  >
    <span>v{{ version }}</span>
    <!-- An update is only ever offered in production: it takes the place of the environment badge. -->
    <ShellUpdateLink
      v-if="shellUpdate.isVisible.value"
      :update="shellUpdate"
    />
    <span v-else-if="env" class="bg-darkPurple font-bold rounded px-2 ml-2 text-xs text-white">{{ env }}</span>
  </div>
</template>

<script lang="ts" setup>
import GlowingContainer from '@/core/components/glowing-container/GlowingContainer.vue';
import {contentfulService, versionApi} from '@/container';
import {useRouter} from "vue-router";
import useSwr from "@/core/composables/swr/useSwr";
import {computed, onMounted, ref} from "vue";
import {cacheKey} from "@/lib/cache";
import ShellUpdateLink from "@/shell-update/components/ShellUpdateLink.vue";
import useShellUpdate from "@/shell-update/composables/useShellUpdate";

const router = useRouter();

const version = ref<string>('');

const shellUpdate = useShellUpdate();

const key = computed(() => {
    return version.value ? cacheKey('release-highlight', {version: version.value}) : null;
});

const {data: release} = useSwr(
    () => key.value,
    () => versionApi().isHighlight(version.value).then((response: any) => response?.id ? response : null),
    contentfulService().swrConfig()
);

onMounted(async () => {
    // window.ipcRenderer is only exposed by the Electron preload; it is undefined
    // when the app runs as a plain web page. Guard the IPC call so the login page
    // does not crash outside Electron (matches the guard in useAlerts).
    if (window.ipcRenderer) {
        version.value = await window.ipcRenderer.invoke('electron-version');
    }
});

const env = computed(() => {
    switch (import.meta.env.MODE) {
        case 'development':
            return 'developpement';
        case 'production':
            return '';
        case 'staging':
            return 'préproduction';
        default:
            return '';
    }
});

/**
 * Redirect to the patch notes page.
 */
const onPress = () => {
    router.push({name: 'patch-notes'});
};
</script>
